
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import InviteFriends from "./pages/InviteFriends";
import MarketPage from "./pages/MarketPage";
import ActivityFeed from "./pages/ActivityFeed";
import ProfilePage from "./pages/ProfilePage";
import QuickGift from "./pages/QuickGift";
import AuthPage from "./pages/AuthPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/invite" element={<InviteFriends />} />
            <Route path="/market" element={<MarketPage />} />
            <Route path="/activity" element={<ActivityFeed />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/quick-gift/:recipientId" element={<QuickGift />} />
            <Route path="/quick-gift" element={<QuickGift />} />
            <Route path="/auth" element={<AuthPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
